// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--MaweT","appear":"styles-module--appear--2viUH","wrap_collapsed":"styles-module--wrap_collapsed--1qNnn"};